import React, { useLayoutEffect } from 'react';
import { GraduationCap, ArrowRight } from 'lucide-react';
import { CampusConnect } from '../components/sections/CampusConnect';
import { WorkshopHighlights } from '../components/sections/WorkshopHighlights';
import { UniqueFeatures } from '../components/sections/UniqueFeatures';
import { StudentTestimonials } from '../components/sections/StudentTestimonials';
import { EducatorTestimonials } from '../components/sections/EducatorTestimonials';
import { RegistrationSection } from '../components/sections/RegistrationSection';
import { ContactFooter } from '../components/sections/ContactFooter';

export const CampusPage = () => {
  useLayoutEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  }, []);

  const handleInviteClick = () => {
    window.location.href = '/joinThinkTech';
  };

  const handleJoinThinkTechClick = () => {
    const registerSection = document.getElementById('register-section');
    if (registerSection) {
      registerSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLogoClick = () => {
    window.location.href = '/';
  };

  return (
    <main className="min-h-screen">
      {/* Sticky Header for Home Page */}
      <header className="sticky top-0 z-50 bg-white border-b shadow-lg" style={{borderColor: '#6B4423'}}>
        <div className="container mx-auto px-3 sm:px-4 md:px-6 py-2 sm:py-3 md:py-4">
          <div className="flex items-center justify-between">
            {/* Left: A2ZCampus Logo and Branding */}
            <button 
              onClick={handleLogoClick}
              className="flex items-center hover:opacity-80 transition-opacity cursor-pointer"
              aria-label="Go to home page"
            >
              <img 
                src="/A2ZAssist%20logo.png" 
                alt="A2ZCampus Logo - India's First ThinkTech Platform for AI, Startups and Real-World Skills Training" 
                className="w-10 h-10 sm:w-12 sm:h-12 md:w-16 md:h-16 lg:w-20 lg:h-20 mr-1 object-contain"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                }}
              />
              <div className="flex items-center">
                <span className="font-bold text-lg sm:text-xl md:text-2xl lg:text-3xl tracking-tight" style={{color: '#2C2420'}}>A2Z</span>
                <span className="font-bold text-lg sm:text-xl md:text-2xl lg:text-3xl tracking-tight" style={{color: '#6B4423'}}>Campus</span>
                <span className="text-xs sm:text-sm md:text-base lg:text-lg font-bold ml-1 align-top" style={{color: '#6B4423'}}>™</span>
              </div>
            </button>
            
            {/* Right: ThinkTech Badge with Join Button - Hidden on mobile, shown on larger screens */}
            <div className="hidden lg:flex items-center gap-4">
              <div className="flex items-center bg-white border-2 rounded-2xl px-6 py-3 shadow-lg" style={{borderColor: '#C4A052'}}>
                <GraduationCap className="w-6 h-6 mr-3" style={{color: '#C4A052'}} />
                <div className="flex items-center">
                  <span className="font-bold text-lg" style={{color: '#6B4423'}}>India's First ThinkTech</span>
                  <span className="text-sm font-bold ml-1 align-top" style={{color: '#6B4423'}}>™</span>
                  <span className="font-bold text-lg ml-2" style={{color: '#6B4423'}}>Platform</span>
                </div>
              </div>
              <button
                onClick={handleJoinThinkTechClick}
                className="px-6 py-3 text-white font-bold text-base rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                style={{backgroundColor: '#C4A052'}}
                aria-label="Join ThinkTech community"
              >
                Join ThinkTech
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <CampusConnect />
      <WorkshopHighlights />
      <UniqueFeatures />
      <div id="register-section">
        <RegistrationSection />
      </div>
      <StudentTestimonials />
      <EducatorTestimonials />
      <ContactFooter />
    </main>
  );
};